import React, { useState } from 'react';
import KaAlert from '../Common/KaAlert';
import { FormCheckbox } from '../Common/FormCheckbox';
import SpinnerButton from '../Common/SpinnerButton';
import { UserProfile } from '../UserAccess/UserContext';
import KaModal from '../Common/KaModal';
import useUserRequest, { UserRequestSpec } from '../Common/useUserRequest';
import { HttpMethod } from '../Common/useFetch';
import useDisplayMessage from '../Common/useDisplayMessage';
import BusinessUserDto from '../Common/dtos/BusinessUserDto';

interface IProps {
  user: UserProfile;
  businessUser: BusinessUserDto;
  visible: boolean;
  onHide: () => void;
  onSuccess: () => void;
}

interface EditUserDto {
  administrator: boolean;
  errorRecipient: boolean;
}

const putSpec = (businessId?: string, userId?: string): UserRequestSpec => ({
  path: `/api/businesses/${businessId}/users/${userId}`,
  method: HttpMethod.PUT,
});

export const EditUser = (props: IProps) => {
  const [administrator, setAdministrator] = useState(props.businessUser.administrator);
  const [errorRecipient, setErrorRecipient] = useState(props.businessUser.isErrorRecipient);
  const displayMessage = useDisplayMessage();
  const requestSpec = putSpec(props.user.selectedBusiness?.id, props.businessUser.id);

  const editUser = useUserRequest<EditUserDto>(requestSpec, {
    onSuccess: () => props.onSuccess(),
    onError: (e) => displayMessage.fail(e.message),
  });

  const onClose = () => {
    props.onHide();
    displayMessage.clear();
  };

  return (
    <KaModal
      onHide={onClose}
      show={props.visible}
      title={`Edit ${props.businessUser.emailAddress}`}
      body={(<>
        <KaAlert displayMessage={displayMessage.message} onClose={displayMessage.clear} />
        <FormCheckbox
          label="Administrator"
          defaultChecked={props.businessUser.administrator}
          onChange={(e) => setAdministrator(e.target.checked)}
          offset={3}
        />
        <FormCheckbox
          label="Subscribe to connector error emails"
          defaultChecked={props.businessUser.isErrorRecipient}
          onChange={(e) => setErrorRecipient(e.target.checked)}
          offset={3}
        />
      </>)}
      footer={(
        <SpinnerButton
          className="btn-ghost-primary"
          spinning={editUser.isLoading}
          onClick={() => editUser.request({ administrator, errorRecipient })}>
          Save
        </SpinnerButton>
      )}
    />
  );
};
